export const REGEX_EMAIL = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export const reCAPTCHA_CLIENT = '6LeMIfQUAAAAAGblGGmutcrS1gaG3YMyRPzkG5N7';

const getBaseURL = () => {
  if (window.location.hostname === 'localhost') {
    return 'https://api.tiiny.host'
  } else {
    return 'https://api.tiiny.host'
  }
};

export const API_ROOT = getBaseURL();
